// Libraries
import { configureStore, ThunkAction, Action, ThunkDispatch, AnyAction } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// Internal imports
import { RootState, rootReducer } from './rootReducer';

// this configuration has a white list and a black list to discriminate the persistence of the data
const persistConfig = {
    key: 'root',
    storage: storage,
    blacklist: ['payrollAdjuster', 'periods'],
};

// connect configuration with reducers modules
const persistedReducer = persistReducer(persistConfig, rootReducer);

// integrate data persistence from global state application
const store = configureStore({
    reducer: persistedReducer,
    devTools: true,
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({
            immutableCheck: false,
            serializableCheck: false,
        }),
});

// connect store with redux persistent
const persistor = persistStore(store);

// Export store and persistor to be used in the index
export { store, persistor };

// Global types async actions thunk
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
export type DispatchExts = ThunkDispatch<RootState, void, AnyAction>;
